import { render } from "./aiUsage.vue?vue&type=template&id=46887b2b&scoped=true"
import script from "./aiUsage.vue?vue&type=script&lang=js"
export * from "./aiUsage.vue?vue&type=script&lang=js"

import "./aiUsage.vue?vue&type=style&index=0&id=46887b2b&lang=scss&scoped=true"

import exportComponent from "C:\\xampp-80\\htdocs\\v2crmred\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46887b2b"]])

export default __exports__